/* Jellymoon · C — añadir al carrito desde la home, el test y el carrito lateral.
   Los botones van dentro de un <form action="/cart/add"> (funcionan sin JS). Con JS se añade por AJAX
   y se lanza el mismo evento que el formulario de producto de Horizon, para que el carrito lateral
   se abra y se repinte solo. */
import { CartLinesUpdateEvent } from '@shopify/events';

async function addToCart(form, button) {
  const fd = new FormData(form);
  const id = String(fd.get('id'));
  const qty = Number(fd.get('quantity') || 1);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId).filter(Boolean);
  if (sectionIds.length) fd.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: id, quantity: qty }],
    promise: deferred.promise,
  }));

  button?.setAttribute('aria-busy', 'true');
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST', body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    }).then((r) => r.json());
    const cart = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'jm-add', sourceId: form.id || 'jm-add', itemCount: qty,
                productId: form.dataset.productId, sections: res.sections, didError: Boolean(res.status) },
    });
    if (res.status) throw new Error(res.description || res.message);
  } catch (err) {
    console.warn('[jm] no se pudo añadir', err);
    deferred.reject?.(err);
  } finally {
    button?.removeAttribute('aria-busy');
  }
}

document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-jm-add]')) return;
  e.preventDefault();
  // «Cambiar a Pack Rescate» (jm-cart-extra): primero quita un bote de la línea, luego añade el pack
  if (form.dataset.swapKey) {
    fetch(`${Theme.routes.cart_change_url}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: form.dataset.swapKey, quantity: Number(form.dataset.swapQty) || 0 }),
    }).then(() => addToCart(form, e.submitter));
    return;
  }
  addToCart(form, e.submitter);
});

/* ---------------- test capilar de la home (3 preguntas) */
class JmTest extends HTMLElement {
  connectedCallback() {
    this.step = 0; this.ans = [];
    this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.box = this.querySelector('[data-box]');
    this.render();
  }
  pick(a) {
    if (a[0] === 'rizo') return 'cb';
    if (a[1] === 'frizz') return a[2] === 'mas' ? 'pk' : 'wb';
    if (a[1] === 'seco') return a[2] === 'mas' ? 'pk' : 'sm';
    return a[2] === 'min' ? 'wb' : 'pk';
  }
  render() {
    const Q = this.data.preguntas;
    const bars = [0, 1, 2].map((i) => `<i class="${i <= this.step ? 'on' : ''}"></i>`).join('');
    if (this.step < 3) {
      const s = Q[this.step];
      this.box.innerHTML = `<div class="jm-prog">${bars}</div><span class="jm-kicker">Pregunta ${this.step + 1} de 3</span><h3>${s.q}</h3>
        <div class="jm-opts">${s.o.map((o) => `<button class="jm-opt" type="button" data-v="${o[1]}">${o[0]}</button>`).join('')}</div>`;
      this.box.querySelectorAll('.jm-opt').forEach((b) => b.addEventListener('click', () => {
        this.ans[this.step] = b.dataset.v; this.step++; this.render();
        this.box.querySelector('h3, .jm-res h3')?.focus?.();
      }));
    } else {
      const r = this.data.productos[this.pick(this.ans)];
      if (!r) { this.box.innerHTML = '<p>Escríbenos y te ayudamos a elegir.</p>'; return; }
      this.box.innerHTML = `<div class="jm-prog">${bars}</div><span class="jm-kicker">Tu tratamiento</span>
        <div class="jm-res"><img src="${r.img}" alt="${r.n}" width="300" height="300"><div style="display:grid;gap:8px"><h3 tabindex="-1">${r.n}</h3><p>${r.t}</p><span class="jm-res__price">${r.p}</span></div></div>
        <div class="jm-res-actions"><a class="jm-btn" href="${r.url}">Ver mi tratamiento</a></div>
        <button class="jm-restart" type="button">Repetir el test</button>`;
      this.box.querySelector('.jm-restart').addEventListener('click', () => { this.step = 0; this.ans = []; this.render(); });
    }
  }
}
if (!customElements.get('jm-test')) customElements.define('jm-test', JmTest);

/* ---------------- Club 20 % del carrito (jm-cart-extra): solo para visitantes que Klaviyo no identifica */
const KL_COMPANY = 'WvVr62';
const CLUB_CODE = 'BIENVENIDA20';
function clubAnon() {
  try { if (localStorage.getItem('jm_club')) return; } catch (e) {}
  const show = () => document.documentElement.classList.add('jm-anon');
  const k = window.klaviyo;
  if (k && typeof k.isIdentified === 'function') {
    Promise.resolve(k.isIdentified()).then((id) => { if (!id) show(); }).catch(show);
  } else show();
}
if (document.readyState === 'complete') clubAnon(); else window.addEventListener('load', clubAnon);

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-jm-club]')) return;
  e.preventDefault();
  const input = form.querySelector('input[type=email]'); const ok = form.querySelector('.jm-cart__club-ok');
  const email = (input.value || '').trim();
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { ok.hidden = false; ok.textContent = 'Revisa el email, parece que falta algo.'; input.focus(); return; }
  const btn = form.querySelector('button'); btn.setAttribute('aria-busy', 'true');
  try {
    const r = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KL_COMPANY}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: `Carrito · ${form.dataset.producto}`,
        profile: { data: { type: 'profile', attributes: { email } } } },
        relationships: { list: { data: { type: 'list', id: form.dataset.lista } } } } }),
    });
    if (!r.ok && r.status !== 202) throw new Error(r.status);
    try { localStorage.setItem('jm_club', '1'); } catch (err) {}
    try { window.klaviyo?.identify?.({ email }); } catch (err) {}
    await fetch(`/discount/${CLUB_CODE}`, { credentials: 'same-origin' }).catch(() => {});
    form.querySelector('.jm-cart__club-f').remove(); form.querySelector('.jm-cart__club-t').remove();
    ok.hidden = false; ok.innerHTML = `<b>¡Hecho!</b> Tu código <b>${CLUB_CODE}</b> (−20 %) se aplica al finalizar el pedido.`;
    form.classList.add('is-ok');
  } catch (err) {
    ok.hidden = false; ok.textContent = 'No hemos podido apuntarte. Prueba otra vez en un momento.';
  } finally { btn?.removeAttribute('aria-busy'); }
});
